<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .paragraph-hubspot
        max-width: 68rem
        padding: 0 7rem

        +media("<=1000px")
            padding: 0 4rem
        +media("<=460px")
            padding: 0 2rem

</style>

<script>
  export default {
    props: ['idForm', 'portalId'],
    mounted() {
    const script = document.createElement("script");
    script.src="https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      if (window.hbspt) {
        console.log('hubspot loaded : ', window.hbspt);
        console.log('props idForm : ', this.idForm);
        console.log('props portalId : ', this.portalId);
        window.hbspt.forms.create({
          region: "eu1",
          portalId: this.portalId,
          formId: this.idForm,
          target: "#hubspotForm"
        })
      }
    })
  }
}
</script>
